import WorkoutLesson2 from "./workout-lesson2";

export default WorkoutLesson2;